module.exports = __webpack_public_path__ + "img/jm.67f96b2f.svg";